export default class GenericDetailed {
  id: string;

  name: string;

  constructor(obj: any) {
    this.id = obj.id || null;
    this.name = obj.name;
  }

  public static of(obj: any = {}): GenericDetailed {
    return new GenericDetailed(obj);
  }

  public static ofList(obj: any[]): GenericDetailed[] {
    return obj.map(this.of)
  }
}
